module.exports = __webpack_public_path__ + "img/sld_scb_7_green.b98514e5.svg";